import { FormAnswers } from './qualification';
import { UTMParams, captureUTMs } from './utm';
import { getTimeBucket, getRevenueBucket, getCreditBucket } from './qualification';

// Replace with your actual ROK white-label URL
export const LENDER_URL = 'https://go.mypartner.io/business-financing/?ref=001Qk00000giOrFIAU';

export function buildApplicationUrl(
  answers: FormAnswers, 
  tier: string, 
  citySlug?: string,
  industry?: string,
  fundingPurpose?: string,
  fundingAmount?: string
): string {
  const utms = captureUTMs();
  const params = new URLSearchParams();

  // Add UTM parameters
  if (utms.utm_source) params.append('utm_source', utms.utm_source);
  if (utms.utm_campaign) params.append('utm_campaign', utms.utm_campaign);
  if (utms.utm_adset) params.append('utm_adset', utms.utm_adset);
  if (utms.utm_ad) params.append('utm_ad', utms.utm_ad);

  // Add qualification parameters
  params.append('tier', tier);
  if (answers.goal) params.append('goal', answers.goal);
  params.append('time_bucket', getTimeBucket(answers.timeInBusiness));
  params.append('revenue_bucket', getRevenueBucket(answers.monthlyRevenue));
  params.append('credit_bucket', getCreditBucket(answers.creditScore));

  // Add city-aware tracking parameters
  if (citySlug) params.append('city', citySlug);
  if (industry) params.append('industry', industry);
  if (fundingPurpose) params.append('funding_goal', fundingPurpose);
  if (fundingAmount) params.append('funding_amount', fundingAmount);
  if (answers.timeInBusiness) params.append('time_in_business', answers.timeInBusiness);
  if (answers.monthlyRevenue) params.append('revenue', answers.monthlyRevenue);

  return `${LENDER_URL}&${params.toString()}`;
}
